"use client";

import { useTranslations } from "next-intl";
import { SurfaceChrome } from "@/components/SurfaceChrome";
import type { BottomNavItem } from "@/components/ui/BottomNav";
import {
  IconCompass,
  IconCalendar,
  IconChat,
  IconShield,
  IconUser,
} from "@/components/ui/icons";

/**
 * Navegación de la superficie CLIENTE (/app). Client component porque los íconos
 * son componentes. Otros agentes: agreguen/renombren rutas acá.
 */
export function ClientNav({
  children,
  notificationBell,
}: {
  children: React.ReactNode;
  notificationBell?: React.ReactNode;
}) {
  const t = useTranslations("common");
  const tb = useTranslations("common.brand");

  const items: BottomNavItem[] = [
    { href: "/app", label: t("nav.discover"), icon: IconCompass, exact: true },
    { href: "/app/bookings", label: t("nav.bookings"), icon: IconCalendar },
    { href: "/app/messages", label: t("nav.messages"), icon: IconChat },
    { href: "/app/safety", label: t("nav.safety"), icon: IconShield },
    { href: "/app/profile", label: t("nav.profile"), icon: IconUser },
  ];

  return (
    <SurfaceChrome items={items} brand={tb("name")} notificationBell={notificationBell}>
      {children}
    </SurfaceChrome>
  );
}
